import React, { FC } from 'react';
import styled from 'styled-components/macro';
import { Trans } from '@lingui/macro';
import { URLS } from 'config';

import Typography from 'components/Typography';

import { SpaceVariants } from 'theme';
import { StyledLink } from 'components/StyledCommon';

/** "or" form separator */
const StyledSeparator = styled((props) => (
    <Typography {...props} variant="bodyxs" align="center" color="baseGray" />
))`
    position: relative;
    margin-left: auto;
    margin-right: auto;

    margin-top: ${({ theme, margin }) => theme.space[margin]};
    margin-bottom: ${({ theme, margin }) => theme.space[margin]};

    &:before {
        content: '';
        position: absolute;
        z-index: 5;
        top: 50%;
        left: 0;
        width: 100%;
        height: 1px;
        background-color: ${({ theme }) => theme.colors.labels};
    }

    span {
        position: relative;
        z-index: 10;
        display: inline-block;
        padding: 0 16px;
        background-color: #fff;
    }
`;

const Separator: FC<{ margin?: SpaceVariants }> = ({
    margin = 'large',
    children,
}) => {
    return (
        <StyledSeparator margin={margin}>
            <span>{children}</span>
        </StyledSeparator>
    );
};

const Root = styled((props) => (
    <Typography spaceTop="medium" align="center" variant="bodyxs" {...props} />
))`
    color: ${({ theme }) => theme.colors.baseGray};
`;

/** Auth terms and conditions */
const Terms = () => {
    return (
        <Root>
            <Trans>
                By using our service, you agree with our{' '}
                <StyledLink $size="bodyxs" $fontWeight={400} href={URLS.terms}>
                    Terms of service
                </StyledLink>
                {', '}
                <StyledLink
                    $fontWeight={400}
                    $size="bodyxs"
                    href={URLS.ccpaNotice}
                >
                    CCPA Notice
                </StyledLink>{' '}
                and{' '}
                <StyledLink
                    $fontWeight={400}
                    $size="bodyxs"
                    href={URLS.privacyNotice}
                >
                    Privacy Notice
                </StyledLink>{' '}
                that details what personal data we collect and use to provide
                you with the best learning experience.
            </Trans>
        </Root>
    );
};

export { Separator, Terms };
